import React from "react";
import "../css/contactus.scss";

function Contact() {
  return (
    <div className="contact">
      <h1>Contact Us</h1>
      <p className="intro">
        We value your feedback, inquiries, and the opportunity to assist you in any way we can. Whether you have a question about our products, need assistance with an order, or simply want to share your thoughts, we're here to help.
      </p>
      <ul>
        <li>
          Tel: For immediate assistance, please contact our customer service hotline at +852 5436 7186
        </li>
        <li>
          Email: If you prefer to communicate in writing, you can send us an email at support@dzcp896.com. Whether you have a specific question, need product recommendations, or require assistance with an existing order, our team will respond promptly with the information you need.
        </li>
        <li>
          Online Form: To streamline your communication, we have an online contact form available on our website. Simply visit dzcp896.com and navigate to the "Contact Us" page to access the form. Please provide your name, email address, and a brief message outlining the nature of your inquiry. Our team will review your submission and respond promptly.
        </li>
      </ul>
    </div>
  );
}

export default Contact;
